import type { WorldTheme } from './theme';

/**
 * United States sky of world 4: San Diego (GDD §11.1, §14.2, issue #135). Pacific blue at night over the bay: a deep blue sky,
 * low blue hills and city blocks along the coast and the Coronado bridge as a distant silhouette (`layer.bridge`, z = -40).
 * It is activated at the border crossing (`border:crossed`, as Miami #97, New York #112 and El Paso #123). The sky is dark
 * so the bills keep 3:1 against it, and every pickup stays more saturated than the decoration (GDD §14.1). Nothing is drawn
 * on the play plane (z = 0).
 */

const SAN_DIEGO = {
  coast: 0x2a5a8a,
  coastSoft: 0x346a9a,
  block: 0x244a72,
  blockDark: 0x1d3d60,
  foreground: 0x10243a,
  bridgeDeck: 0x6a7a90,
  bridgeTower: 0x4a5a70,
} as const;

export const USA_SAN_DIEGO: WorldTheme = {
  id: 'usa-san-diego',
  variant: 'san-diego',
  sky: 0x16365e,
  fog: { color: 0x1d4570, near: 40, far: 150 },
  // The bay: the ground of this sky is the water.
  ground: 0x1f3a52,
  ceiling: 0xa8c8f0,
  collidable: { column: 0x33d060, pickup: 0xe0a000 },
  lights: {
    hemisphere: { sky: 0x9ab8e8, ground: 0x1a2a40, intensity: 0.9 },
    sun: { color: 0xb8d0ff, intensity: 1.3, position: [-6, 12, 12] },
  },
  layers: [
    { name: 'layer.far', colors: [SAN_DIEGO.coast, SAN_DIEGO.coastSoft], moduleWidth: 26, height: 8, baseY: 1, motif: 'hills' },
    { name: 'layer.mid', colors: [SAN_DIEGO.block, SAN_DIEGO.blockDark], moduleWidth: 15, height: 4.5, baseY: 1, motif: 'buildings' },
    { name: 'layer.foreground', colors: [SAN_DIEGO.foreground], moduleWidth: 10, height: 1.4, baseY: -0.6, motif: 'foreground', followCamera: true },
  ],
  bridge: { deck: SAN_DIEGO.bridgeDeck, tower: SAN_DIEGO.bridgeTower },
};
